import { TFunction } from 'i18next';
import { AvailabilityStatusEnum, AvailabilityTypeEnum, DatetimeOrDateField, WorkDay, WorkWeek } from 'openapi';

export const availabilityTypeToString = (t: TFunction, type: AvailabilityTypeEnum): string => {
  switch (type) {
    case AvailabilityTypeEnum.AVAILABLE:
      return t('availability-extra-planned', 'Extra planned');
    case AvailabilityTypeEnum.LEAVE:
      return t('availability-extra-leave', 'Leave');
    case AvailabilityTypeEnum.OVERTIME:
      return t('availability-extra-overtime', 'Overtime');
    case AvailabilityTypeEnum.SICK:
      return t('availability-extra-sick', 'Sick');
  }
};

export const parseDatetimeOrDateField = (dateOrTime: DatetimeOrDateField): Date => {
  if (dateOrTime.datetime) {
    return new Date(dateOrTime.datetime ?? '');
  } else {
    return new Date(dateOrTime.date ? dateOrTime.date + 'T00:00:00' : '');
  }
};

export const formatDatetimeOrDate = (
  dateOrTime: DatetimeOrDateField,
  formatDateTime: (dateTime: Date) => string,
  formatDate: (date: Date) => string,
): string => {
  if (dateOrTime.datetime) {
    return formatDateTime(new Date(dateOrTime.datetime ?? ''));
  } else {
    return formatDate(new Date(dateOrTime.date ? dateOrTime.date + 'T00:00:00' : ''));
  }
};

export const availabilityStatusToString = (t: TFunction, status: AvailabilityStatusEnum): string => {
  switch (status) {
    case AvailabilityStatusEnum.CANCELLED:
      return t('status-cancelled', 'Cancelled');
    case AvailabilityStatusEnum.CONFIRMED:
      return t('status-approved', 'Approved');
    case AvailabilityStatusEnum.REJECTED:
      return t('status-rejected', 'Rejected');
    case AvailabilityStatusEnum.TENTATIVE:
      return t('status-tentative', 'Tentative');
  }
};

export const availabilityTypeColor = (type: AvailabilityTypeEnum): string => {
  switch (type) {
    case AvailabilityTypeEnum.AVAILABLE:
      return '#0E9F6E';
    case AvailabilityTypeEnum.LEAVE:
      return '#C27803';
    case AvailabilityTypeEnum.OVERTIME:
      return '#7E3AF2';
    case AvailabilityTypeEnum.SICK:
      return '#E02424';
  }
};

export const workDayForIndex = (workWeek: WorkWeek, index: number): WorkDay | null => {
  switch (index) {
    case 0:
      return workWeek.monday ?? null;
    case 1:
      return workWeek.tuesday ?? null;
    case 2:
      return workWeek.wednesday ?? null;
    case 3:
      return workWeek.thursday ?? null;
    case 4:
      return workWeek.friday ?? null;
    case 5:
      return workWeek.saturday ?? null;
    case 6:
      return workWeek.sunday ?? null;
    default:
      throw Error('Invalid week index');
  }
};

export const formatHoursToString = (t: TFunction, hours: number): string => {
  const fullHours = Math.floor(hours);
  const decimal = hours - Math.floor(hours);
  const minutes = decimal * 60;
  return t('leave-balance-hours', '{{fullHours}}h {{minutes}}m', { fullHours, minutes });
};
